<template>
  <div class="bg-white">
    <div class="p-6 shadow-border-b">
      <p class="font-bold text-lg mb-6">Tambah Role</p>
      <div class="flex justify-between items-end gap-12">
        <div class="w-1/2">
          <div class="mb-6 max-w-sm">
            <TextField type="text" label="ID" :disabled="true" v-model="id" />
          </div>
          <div class="">
            <TextField type="text" label="Nama Role" placeholder="Nama Role" v-model="payloads.name" />
          </div>
        </div>
        <div class="w-1/2">
          <Textarea label="Role Deskripsi" placeholder="Deskripsi" v-model="payloads.description" />
        </div>
      </div>
    </div>
    <div class="flex items-stretch shadow-border-b">
      <div class="w-4/12 p-6 ">
        <p class="font-bold text-lg mb-6">Permission Group</p>
        <ul>
          <li v-for="(item, group) in permissionByGroup" :key="'item-' + group" class="mb-3">
            <span
              v-if="group === 'Allowed to Manage all'"
              class="inline-block cursor-pointer font-medium hover:text-primary-600"
              @click="select('all')"
              :class="{ 'text-primary-600': selectedMenu === group }"
              >All</span
            >
            <span v-else class="inline-block cursor-pointer font-medium hover:text-primary-600" @click="select(group)" :class="{ 'text-primary-600': selectedMenu === group }">{{ group }}</span>
          </li>
        </ul>
      </div>
      <div class="w-8/12 p-6 shadow-border-l">
        <p class="font-bold text-lg mb-6">Capability</p>
        <masonry :cols="2" :gutter="30">
          <div v-for="(permission, group) in filteredData" :key="permission.id" class="py-2 block">
            <p class="font-bold">{{ group }}</p>
            <div class="flex gap-6 justify-between items-center py-2" v-for="(item, index) in permission" :key="'item' + index">
              <input type="checkbox" class="styled-checkbox" name="goodsCategory" :id="item.id" :value="item.id" v-model="payloads.permissions" />
              <label :for="item.id" class="text-sm">{{ item.id }}</label>
            </div>
          </div>
        </masonry>
      </div>
    </div>
    <div class="flex justify-between items-center p-6">
      <div class="flex gap-6 items-center">
        <Button buttonText="Pilih Semua" @action="selectAll()" type="secondary" :size="isMobile ? 'full' : 'regular'" />
        <Button buttonText="Reset Semua" @action="resetAll()" type="secondary" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="">
        <Button buttonText="Simpan" @action="submit()" type="secondary" :size="isMobile ? 'full' : 'regular'" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea')
    // Chevron: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Chevron')
  },
  data: () => ({
    payloads: {
      name: null,
      description: null,
      is_active: true,
      permissions: []
    },
    status: false,
    name: '',
    selectedPermission: [],
    selectedMenu: null,
    permissionByGroup: [],
    filteredData: [],
    id: null
  }),
  created() {
    this.getPermission()
  },
  computed: {
    ...mapGetters('role', ['permissionList']),
    ...mapGetters('common', ['isMobile'])
  },
  methods: {
    ...mapActions('role', ['getPermissionList', 'createRole']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    selectAll() {
      this.permissionList.forEach(item => this.payloads.permissions.push(item.id))
    },
    resetAll() {
      this.payloads.permissions = []
    },
    select(code) {
      if (code === 'all') {
        this.selectedMenu = 'Allowed to Manage all'
        this.filteredData = this.permissionByGroup
      } else {
        this.selectedMenu = code

        const filtered = Object.keys(this.permissionByGroup)
          .filter(key => key === code)
          .reduce((obj, key) => {
            obj[key] = this.permissionByGroup[key]
            return obj
          }, {})

        this.filteredData = filtered
      }
    },
    getPermission() {
      this.showLoading()
      this.getPermissionList({
        params: {
          page: 1,
          per_page: 100,
          search_keyword: ''
        }
      })
        .then(() => {
          this.permissionByGroup = this.groupBy(this.permissionList, 'permission_group_name')
          this.filteredData = this.permissionByGroup
          this.select('all')
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    goBack() {
      this.$router.push('/role/list')
    },
    save() {
      this.showLoading()
      this.createRole({
        payloads: {
          name: this.name,
          is_active: this.status,
          permissions: this.selectedPermission
        }
      })
        .then(res => {
          this.hideLoading()
          this.$router.push('/role/list')
        })
        .catch(error => {
          this.hideLoading()
        })
    },
    groupBy(arr, key) {
      const initialValue = {}
      return arr.reduce((acc, cval) => {
        const myAttribute = cval[key]
        acc[myAttribute] = [...(acc[myAttribute] || []), cval]
        return acc
      }, initialValue)
    },
    submit() {
      this.showLoading()
      this.createRole({
        payloads: this.payloads
      }).then(() => {
        this.$router.push('/user/role')
        this.hideLoading()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }

  // Box.
  & + label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border: 1px solid #2e9c95;
    border-radius: 4px;
  }

  // Box hover
  &:hover + label:before {
    background: #2e9c95;
  }

  // Box focus
  &:focus + label:before {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
  }

  // Box checked
  &:checked + label:before {
    background: #2e9c95;
  }

  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(45deg);
  }
}
input:checked[type='checkbox'] + span {
  left: 1.5rem;
  top: 0;
  background-color: #f2994a;
}
input:checked[type='checkbox']:disabled {
  background-color: rgba(25, 21, 255, 0.5);
}
input:checked[type='checkbox']:disabled + span {
  background-color: rgb(93, 91, 233);
  box-shadow: none;
}
input[type='checkbox']:disabled + span {
  background-color: rgb(214, 211, 211);
  box-shadow: none;
}
</style>
